import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { businessCardService } from '../../services/api';

const BusinessCardAttachment = (props) => {
  const data = props.attachments?.[0] || {};
  const { html, business_card_id } = data;
  const [saved, setSaved] = useState(!!data.contact_id); // in case backend patches message later
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (saving || saved) return;
    setSaving(true);
    const res = await businessCardService.saveBusinessCard(business_card_id);
    if (res.success) {
      setSaved(true);
      toast.success('Contact saved successfully');
    } else {
      // Extract error message properly - API returns {detail: "message"} in error response
      const errorMessage = res.error?.detail || res.error || 'Failed to save contact';
      
      // Handle specific error message for existing contact
      if (errorMessage === 'Contact already exists.') {
        toast.error('Contact already exists.');
      } else {
        toast.error(errorMessage);
      }
    }
    setSaving(false);
  };

  if (!html) return null;

  return (
    <div className="p-4 border rounded-lg bg-white shadow-sm max-w-xs">
      <div className="prose" dangerouslySetInnerHTML={{ __html: html }} />
      {!saved ? (
        <button
          onClick={handleSave}
          disabled={saving}
          className="mt-3 w-full bg-blue-500 hover:bg-blue-600 text-white py-1.5 rounded-md text-sm"
        >
          {saving ? 'Saving…' : 'Save to Contacts'}
        </button>
      ) : (
        <span className="inline-block mt-3 text-emerald-600 text-sm">Saved ✔︎</span>
      )}
    </div>
  );
};

export default BusinessCardAttachment; 